(function (global, factory) {
typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
typeof define === 'function' && define.amd ? define(['react'], factory) :
(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.ClickToEdit = factory(global.React));
}(this, (function (React) { 'use strict';

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".CTE--wrapper {\n    display: inline-grid;\n    white-space: pre-wrap;\n  }\n  .CTE--wrapper:after, .CTE--input, .CTE--text {\n    grid-area: 1 / 2;\n    /* resize: none; */\n    text-align: center;\n    font-size: inherit;\n    font-family: inherit;\n  }\n  .CTE--wrapper:after {\n    content: attr(data-value) ' ';\n    height: 0;\n    visibility: hidden;\n    white-space: pre-wrap;\n  }\n  .CTE--input {\n    margin: 0;\n    padding: 0;\n    border:0;\n    background:none;\n    align-self: baseline;\n    outline: none;\n    box-sizing: border-box;\n  }\n  .CTE--text {\n  }\n";
styleInject(css_248z);

const ClickToEdit = (props) => {
    const [value, setValue] = React.useState(props.initialValue);
    const [isEditMode, setEditMode] = React.useState(false);
    const getIntoEditMode = () => {
        if (props.startEditing && !isEditMode) {
            props.startEditing();
        }
        setEditMode(true);
    };
    const getOffEditMode = () => {
        setEditMode(false);
        if (props.endEditing) {
            props.endEditing(value);
        }
    };
    const handleChange = (e) => {
        setValue(e.target.value);
    };
    const handleKeyPress = (e) => {
        if (e.code === "Escape" || e.code === "Enter") {
            getOffEditMode();
        }
    };
    return (React__default['default'].createElement("section", { "data-value": value, className: classnames("CTE--wrapper", props.wrapperClass) }, isEditMode ? (React__default['default'].createElement("input", { type: "text", autoFocus: true, value: value, className: classnames("CTE--input", props.inputClass), onChange: handleChange, onKeyPress: handleKeyPress, onBlur: getOffEditMode, size: 1 })) : (React__default['default'].createElement("span", { className: classnames("CTE--text", props.textClass), onClick: getIntoEditMode }, value))));
};

return ClickToEdit;

})));
